export default __webpack_public_path__ + "b9f78804990edd77b4a4d2584ec4f560.png";